module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "学号",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "姓名",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.stuName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuName", $$v)
      },
      expression: "queryForm.stuName"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "开始日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "startTime", $$v)
      },
      expression: "queryForm.startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "结束日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.queryForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "endTime", $$v)
      },
      expression: "queryForm.endTime"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "审核状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.comboData.auditState), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 申请")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "cell-style": _vm.handleCellStyle,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": _vm.mainTableHeight
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.limit + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学号",
      "prop": "stuCode",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "stuName",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "异动类型",
      "prop": "changeName",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "异动原因",
      "prop": "reasonName",
      "align": "center",
      "width": "300px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "异动日期",
      "prop": "changeTime",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "异动说明",
      "prop": "desc",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提交状态",
      "prop": "submitState",
      "formatter": _vm.submitStateFormatter,
      "align": "center",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态",
      "prop": "auditState",
      "formatter": _vm.auditStateFormatter,
      "align": "center",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.submitState == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.modRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.submitState == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.delRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.submitState == '1' && scope.row.auditAuth == '0') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showDetailInfo(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 详情\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.auditAuth == '1') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.auditRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 审核\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.submitState == '1' || scope.row.auditState != '') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showAuditList(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document"
        }), _vm._v(" 审核信息\n                ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "900px",
      "top": "150px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-form', {
    ref: "changeStatusForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "120px",
      "label-position": "left",
      "width": "100%",
      "rules": _vm.curdRules
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "编号",
      "prop": "id"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.curdForm.id),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "id", $$v)
      },
      expression: "curdForm.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teaAuthVisible),
      expression: "teaAuthVisible"
    }],
    attrs: {
      "label": "学生",
      "prop": "stuInfo"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchStu,
      "placeholder": "可输入学号或姓名搜索学生",
      "trigger-on-focus": false,
      "clearable": ""
    },
    on: {
      "clear": _vm.clearSelectStu
    },
    model: {
      value: (_vm.stuInfo),
      callback: function($$v) {
        _vm.stuInfo = $$v
      },
      expression: "stuInfo"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stuAuthVisible),
      expression: "stuAuthVisible"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学号",
      "prop": "stuCode"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.curdForm.stuCode) + "\n                        "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.curdForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "stuCode", $$v)
      },
      expression: "curdForm.stuCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "stuName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.curdForm.stuName) + "\n                        "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.curdForm.stuName),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "stuName", $$v)
      },
      expression: "curdForm.stuName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "异动类型"
    }
  }, [_vm._v("\n                        转专业\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "异动日期",
      "prop": "changeTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "异动日期"
    },
    model: {
      value: (_vm.curdForm.changeTime),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "changeTime", $$v)
      },
      expression: "curdForm.changeTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "异动原因",
      "prop": "reasonCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择异动原因"
    },
    model: {
      value: (_vm.curdForm.reasonCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "reasonCode", $$v)
      },
      expression: "curdForm.reasonCode"
    }
  }, _vm._l((_vm.comboData.reasonCode), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "原专业码",
      "prop": "oriMajorCode"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.curdForm.oriMajorCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "oriMajorCode", $$v)
      },
      expression: "curdForm.oriMajorCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原专业",
      "prop": "oriMajorName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.curdForm.oriMajorName) + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现专业",
      "prop": "newMajorCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择现专业"
    },
    on: {
      "change": _vm.loadClassCombo
    },
    model: {
      value: (_vm.curdForm.newMajorCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "newMajorCode", $$v)
      },
      expression: "curdForm.newMajorCode"
    }
  }, _vm._l((_vm.comboData.major), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "原班级码",
      "prop": "oriClassCode"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.curdForm.oriClassCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "oriClassCode", $$v)
      },
      expression: "curdForm.oriClassCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原班级",
      "prop": "oriClassName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.curdForm.oriClassName) + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现班级",
      "prop": "newClassCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择现班级"
    },
    model: {
      value: (_vm.curdForm.newClassCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "newClassCode", $$v)
      },
      expression: "curdForm.newClassCode"
    }
  }, _vm._l((_vm.comboData.class), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "异动说明",
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写异动说明",
      "autoComplete": "on",
      "type": "textarea",
      "rows": 5,
      "show-word-limit": "",
      "maxlength": "500"
    },
    model: {
      value: (_vm.curdForm.desc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "desc", $$v)
      },
      expression: "curdForm.desc"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveRec
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveAndSubmitRec
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), (_vm.detailDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.detailDialogTitle,
      "visible": _vm.detailDialogVisible,
      "width": "900px",
      "top": _vm.detailDialogTop
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学号"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData.stuCode))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData.stuName))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "异动类型"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData.changeName))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "异动日期"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData.changeTime))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "异动原因"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData.reasonName))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectRowData.changeCode == '11'),
      expression: "selectRowData.changeCode=='11'"
    }],
    attrs: {
      "label": "异动去向学校"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newSchooleCode) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原专业"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData.oriMajorName))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现专业"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newMajorName) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原班级"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData.oriClassName))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现班级"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectRowData.newClassName) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "异动说明"
    }
  }, [_vm._v(_vm._s(_vm.selectRowData.desc))])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auditAreaVisible),
      expression: "auditAreaVisible"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('audit', {
    ref: "audit",
    attrs: {
      "itemCode": _vm.auditParam,
      "relatedCode": _vm.selectRowData.id,
      "auditLevel": _vm.selectRowData.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "900px",
      "top": "150px"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.selectRowData.id,
      "listHeight": 450
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8305b0a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/baseInfo/student/changeMajor.vue
// module id = 1880
// module chunks = 502